import { adminHttpClient } from '../../../commons/adminHttpClient'

export type GetIchraClassDesignWizardStateResponse = {
  id: string
  name: string
  reimbursementProduct: number
  offerSameAllowance: boolean
  waitingPeriod: number
  familyAllowances: number[]
  wizardStatus: number
  stateId: string
  classTypeIds: number[]
}

const getClassDesignWizardState = (productId: string): Promise<GetIchraClassDesignWizardStateResponse> => {
  return adminHttpClient.get(`Benefit/BenefitRenewal/Ichra/ClassDesignWizardState/${productId}`)
}

export default getClassDesignWizardState
